import * as React from 'react';
import { ActionLink } from '@cian/ui-kit';

export interface IMobileMapButtonProps {
  onClick(): void;
}

export const MobileMapButton = ({ onClick }: IMobileMapButtonProps): React.JSX.Element => (
  <ActionLink data-testid="newbuildings-map-button" color="default" fontSize="M" fontWeight="bold" onClick={onClick}>
    Все ЖК на карте
  </ActionLink>
);
